import './accionesEmpleadosGrid.scss';
import React, { useContext, useState, useRef, useEffect } from 'react';
import { AccionesEmpleadosContext } from '../../../../context/accionesempleados/AccionesEmpleadosContext';
import useDocumentTitle from '../../../../components/Title';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Switch, Typography, Grid } from '@mui/material';
import { fetchEntityAccionesData, fetchEntityRolesAccionesData } from './configGrid/apiCalls';

const AccionesEmpleadosGrid = ({ idEmpleado, nombreEmpleado }) => {
  useDocumentTitle("Lista de Permisos del Empleado");
  const contexto = useContext(AccionesEmpleadosContext);
  const {
    getAccionesEmpleadosPanelData,
    getAccionesListaData,
    postAccionEmpleadoData,
    deleteAccionEmpleadoData,
  } = contexto;

  const [accionesEmpleadosData, setAccionesEmpleadosData] = useState([]);
  const [accionesData, setAccionesData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalAcciones, setTotalAcciones] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const isFetchingRef = useRef(false);
  const [selectedModule, setSelectedModule] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems } = await fetchEntityRolesAccionesData(getAccionesEmpleadosPanelData, idEmpleado);
      setAccionesEmpleadosData(dataEntity);
      setTotalItems(totalItems);
      const { dataEntityAcciones, totalAcciones } = await fetchEntityAccionesData(getAccionesListaData);
      setAccionesData(dataEntityAcciones);
      setTotalAcciones(totalAcciones);
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };
  const groupedActions = (accionesData || []).reduce((acc, action) => {
    const [accion, modulo] = action.id.split(':');
    if (!acc[modulo]) {
      acc[modulo] = { modulo, acciones: [] };
    }
    acc[modulo].acciones.push({
      id: accion,
      descripcion: action.descripcion || accion,
    });
    return acc;
  }, {});

  const groupedActionsArray = Object.values(groupedActions);

  const getActionState = (accion, modulo) => {
    return accionesEmpleadosData?.some(
      (empleadoAction) => empleadoAction?.accion_id === `${accion}:${modulo}`
    );
  };

  const handleSwitchChange = (accion, modulo) => {
    const currentState = getActionState(accion, modulo);

    if (currentState) {
      const action = accionesEmpleadosData?.userAcciones?.find(
        (empleadoAction) => empleadoAction?.accion_id === `${accion}:${modulo}`
      );
      if (action) deleteAccionEmpleadoData(action.id);
    } else {
      postAccionEmpleadoData({ sel_id: idEmpleado, accion_id: `${accion}:${modulo}`, estado: true });
    }
  };
  const cellStyle = { height: '20px', padding: '0px', wordWrap: 'break-word' };

  if (isLoading) {
    return (
      <Typography variant="h6" align="center">
        Cargando datos...
      </Typography>
    );
  }

  return (
    <Grid container spacing={3} className="acciones-empleados-grid">
      {(!accionesEmpleadosData || totalItems === 0) ? (
        <Grid item xs={12}>
          <Typography variant="h6" align="center" color="textSecondary" style={{ padding: '20px' }}>
            Este usuario no tiene permisos
          </Typography>
        </Grid>
      ) : (
        <>
          <Grid item xs={12} md={4}>
            <TableContainer component={Paper} className="module-table" style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow style={cellStyle}>
                    <TableCell style={{ ...cellStyle, width: '150px', whiteSpace: 'nowrap' ,fontFamily: 'Arial, sans-serif',color: '#333', backgroundColor: '#f5f5f5', fontWeight: 'bold',fontSize: '24px' }}>
                      Módulo
                      </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groupedActionsArray.map((group, index) => (
                    <TableRow key={index}  style={cellStyle} onClick={() => setSelectedModule(group.modulo)}>
                      <TableCell style={{...cellStyle,textAlign: 'center',wordWrap: 'break-word' }}>
                        <Button style={{ textAlign: 'center' }}>
                          {group.modulo.charAt(0).toUpperCase() + group.modulo.slice(1)}
                        </Button>
                      </TableCell>
                    </TableRow>

                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {selectedModule && (
            <Grid item xs={12} md={8}>
              <TableContainer component={Paper} className="permissions-table">
                <Typography variant="h6" style={{ padding: '10px' }}>
                  Permisos del módulo: {selectedModule}
                </Typography>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={cellStyle}> N° </TableCell>
                      <TableCell style={cellStyle}> Permiso</TableCell>
                      <TableCell style={cellStyle}> Estado</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupedActions[selectedModule].acciones.map((accion, index) => (
                      <TableRow key={index} style={cellStyle}>
                        <TableCell style={cellStyle}>
                            {index + 1}
                        </TableCell>
                        <TableCell style={cellStyle}>
                          {accion.descripcion.charAt(0).toUpperCase() + accion.descripcion.slice(1)}
                        </TableCell>
                        <TableCell style={cellStyle}>
                          <Switch
                            checked={getActionState(accion.id, selectedModule)}
                            onChange={() => handleSwitchChange(accion.id, selectedModule)}
                          />
                        </TableCell>
                      </TableRow>

                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

export default AccionesEmpleadosGrid;
